import { makeStyles } from '@material-ui/core/styles';
import percentFormatter from '@sprinx/formatting/percentFormatter';
import { StandardDivProps } from '@sprinx/react-mui-components/StandardDiv';
import withThemeProps from '@sprinx/react-mui-components/withThemeProps';
import clsx from 'clsx';
import React from 'react';

export interface ProductDiscountPercentElementProps extends StandardDivProps<ProductDiscountPercentElementClassKey> {
  labelEnd?: React.ReactNode;
  labelStart?: React.ReactNode;
  value: undefined | number;
}

export type ProductDiscountPercentElementClassKey = 'root' | 'value' | 'label' | 'unit';

const themeSettings = { name: 'ProductDiscountPercentElement' };
const useStyles = makeStyles(
  (/* theme */) => ({
    root: {},
    value: {
      whiteSpace: 'nowrap',
    },
    label: {},
    unit: {},

    // internal
    padLeft: {
      marginLeft: '1ch',
    },
    padRight: {
      marginRight: '1ch',
    },
  }),
  themeSettings,
);

const ProductDiscountPercentElement = React.forwardRef<HTMLDivElement, ProductDiscountPercentElementProps>(
  ({ className, classes: pClasses, labelEnd, labelStart, value, ...rest }, ref) => {
    const classes = useStyles({ classes: pClasses });

    return value === undefined || value === null ? null : (
      <div ref={ref} className={clsx(classes.root, className)} {...rest}>
        {labelStart && <span className={clsx(classes.padRight, classes.label)}>{labelStart}</span>}
        <span className={classes.value}>{percentFormatter(value * -1)}</span>
        {labelEnd && <span className={clsx(classes.padLeft, classes.label)}>{labelEnd}</span>}
      </div>
    );
  },
);

ProductDiscountPercentElement.displayName = 'ProductDiscountPercentElement';

export default withThemeProps(themeSettings)(ProductDiscountPercentElement);
